import FormatterUtils from './formatter.utils';

export default class ArrayUtils {
  static range(end) {
    return [...Array(end).keys()];
  }

  static groupTransactions(transactions = [], getCurrencyCallback) {
    const grouped = {};
    transactions.forEach(tr => {
      const key = FormatterUtils.shortDate(tr.createAt);

      const amountWithCurrency = FormatterUtils.currency(
        tr.amount,
        getCurrencyCallback(tr.currencyCode),
      ).replace('.00', '');

      const transaction = {
        merchant: tr.metadata.merchant,
        source: tr.metadata.source,
        amount: amountWithCurrency,
        type: tr.transactionType,
        sign: tr.type,
        raw: tr,
      };
      if (grouped[key]) {
        grouped[key].push(transaction);
      } else {
        grouped[key] = [transaction];
      }
    });

    return Object.keys(grouped).map(key => ({
      date: key,
      transactions: grouped[key],
    }));
  }

  static mergeTransactions(list1 = [], list2 = []) {
    const lastItem = list1.pop();
    const firstItem = list2.shift();

    if (lastItem.date === firstItem.date) {
      return [
        ...list1,
        {
          date: lastItem.date,
          transactions: [...lastItem.transactions, ...firstItem.transactions],
        },
        ...list2,
      ];
    }

    return [...list1, lastItem, firstItem, ...list2];
  }
}
